import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { store } from "../redux/store";
import { showToaster } from "../redux/toastSlice";
export const PostApiMethod = (
    routeName: string,
    body: object,
    headers: { [index: string]: { [index: string]: string } } = { headers: {} }
) => {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/${routeName}`,
        body,
        headers
    );
};

export const GetApiMethod = (routeName: string , headers: { [index: string]: { [index: string]: string } } = { headers: {} }) => {
    return axios.get(
        `${process.env.REACT_APP_API_URL}/${routeName}`,
        headers
    );
};

export const PutApiMethod = (routeName: string, body: object) => {
    return axios.put(
        `${process.env.REACT_APP_API_URL}/${routeName}`,
        JSON.stringify(body)
    );
};

export const DeleteApiMethod = (routeName: string) => {
    return axios.delete(`${process.env.REACT_APP_API_URL}/${routeName}`);
};

export const restrictIntialSpace = (e:any) =>{
    if (e.keyCode === 32 && !e.target.value.length){
        e.preventDefault();
    }
}
export const CheckPropertyExistOrNot = (data:any , key:string , loop?:string) => {
    if(loop){
        return ((loop in data && data[loop] && key in data[loop])? data[loop][key] :"-" )
    }
    return (key in data ? data[key] : "-");
}

export const textValidator = (payload: Array<{value: string, maxLength: number | null, minLength: number | null, key: string}>) =>{

    let error:Array<{"key": string, "type": string}> = [];
    payload.forEach(textField => {
        if (textField && textField.value && textField.maxLength && textField.value.trim().length > textField.maxLength)
            error.push({"key": textField.key, "type": "maxLength"});
        if (textField && textField.value && textField.minLength && textField.value.trim().length < textField.minLength)
            error.push({"key": textField.key, "type": "minLength"});
    });
    return { "validation": (error && error.length > 0)? true : false, "error": error};
}


export const Checkeligibility = (editpathname: string, locations: any, redirectTo: string) => {

    const navigate = useNavigate();
    React.useEffect(()=>{
        if (editpathname === locations.pathname) {
            if (locations.state === null) {
            navigate(redirectTo);
            }
        }
    })
}


export const ActivateDeactivate =
    (
        PageName: string,
        name: string,
        route: string,
        id: string,
        status: boolean,
        routeTopage: any
    ) => {

        PutApiMethod(`${route}/delete/${id}`, { isActive: !status })
            .then((res) => {
                if (res.data.status === "Success") {
                    routeTopage();
                    DisplayToaster("bg-success", PageName + " " + "<b>" + name + "</b> has been " + (status ? "deactivated" : "activated") + " successfully");
                }
            })
            .catch((err) => {
                let err_msg = "";
                let cnt = 0;
                if (err.response.data.errors !== undefined) {
                    err.response.data.errors.forEach((err: any, index: any) => {
                        cnt += 1;
                        err_msg += cnt + ". " + err.msg + "\n";
                    });
                }
                if (err.response.data.error !== undefined) {
                    err_msg = err.response.data.error ? err.response.data.error : "Something went wrong!";
                }
                DisplayToaster("bg-danger", err_msg);
            });
    }

    export const DisplayToaster = (bg_color: string, message: string, timer?: string) => {

        store.dispatch(showToaster(
            {
                dialogBgColor: bg_color,
                dialogMsg: message,
                showDialog: true,
                timer: timer ? timer : '5000'
            }));
    }

    export const DisplayErrorMessages = (err: any) => {
        let err_msg = "";
        let cnt = 0;
        if (err.response.data.errors !== undefined) {
            err.response.data.errors.forEach((err: any, index: any) => {
                cnt += 1;
                err_msg += cnt + ". " + err.msg + "\n";
            });
        }
        if (err.response.data.error !== undefined) {
            err_msg = err.response.data.error ? err.response.data.error : "Something went wrong!";
        }
        return err_msg;
    }